/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const integritee_chain_about = () => `Integritee is a blockchain project focused on providing privacy-preserving solutions for dApps and smart contracts. It aims to enable confidential computing on public blockchains, allowing sensitive data to be processed securely without compromising privacy. Integritee utilizes trusted execution environments (TEEs), such as Intel SGX, to create secure enclaves where data can be processed confidentially. This ensures that data remains encrypted and inaccessible to anyone, including the network validators or operators, while it is being processed. This idea opens up new possibilities for privacy-focused applications in finance, healthcare, and so on.`
